'use client';

import { useProductLink } from '@dealerportal/catalog-ui/Hooks/useProductLink';
import type { PaginatedProduct } from '@dealerportal/common';
import Link from 'next/link';
import type React from 'react';

export const ProductLink = ({
  product,
  children,
  className,
  seeInRoom,
  id,
  ...rest
}: React.PropsWithChildren<{
  product: Pick<PaginatedProduct, 'slug' | 'sku'>;
  className?: string | undefined;
  seeInRoom?: boolean;
  id?: string;
}> &
  React.AnchorHTMLAttributes<HTMLAnchorElement>) => {
  const { generateProductLink } = useProductLink();
  return (
    <Link
      href={generateProductLink(product, { seeInRoom })}
      prefetch={false}
      className={className}
      id={id}
      {...rest}
    >
      {children}
    </Link>
  );
};
